import {layoutMarkup} from "../layout/layoutMarkup.js";
import {componentsHelper} from "../../helpers/componentsHelper.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import l10n from '../../../lang/locallang';

const imageSection = (param, is_public = false) => {
    const { imageCaption } = l10n.editor;
    let img_url = param.content && param.content.image_url ? param.content.image_url : '../../images/editor/CG_625252162.jpeg';
    let image_caption = param.content && param.content.image_caption ? param.content.image_caption : '';
    let image_alt = param.content && param.content.image_alt ? param.content.image_alt : '';
    let asset_id = param.content && param.content.asset_id ? param.content.asset_id : componentsHelper.setAssetUniqueID(null, 1, param.id, 'image');
    let imageClass = param['@layout'] === 'imageFullWidth' ? 'editor-section editor-image is-full-width' : 'editor-section editor-image';
    param.class = param.class ? param.class : imageClass;
    param.layout = param['@layout'] ? param['@layout'] : 'imageContainerWidth';
    param.style = param.style ? param.style : '';
    param.section = 'imageSection';
    param.component = `
        <div class="editor-section_container image-container">
            <figure class="image-container_figure">
                <img src="${img_url}" alt="${image_alt}" data-asset-id="${asset_id}">
                <figcaption class="image-container_caption" ${!is_public ? `placeholder="${imageCaption}" contenteditable="true"` : ''}>${image_caption}</figcaption>
            </figure>
        </div>`;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {imageSection};
